var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "BaseModal",
    {
      attrs: { bus: _vm.busModal },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function(ref) {
            var close = ref.close
            return [
              _c("v-spacer"),
              _c(
                "BaseButton",
                { attrs: { underlined: "" }, on: { click: close } },
                [_vm._v(" Cancelar ")]
              ),
              _c(
                "BaseButton",
                {
                  attrs: { primary: "", loading: _vm.loading },
                  on: { click: _vm.enviar }
                },
                [_vm._v(" Excluir ")]
              ),
              _c("v-spacer")
            ]
          }
        }
      ])
    },
    [
      _c("Title", { attrs: { title: "Excluir ativo" } }),
      _c(
        "div",
        [
          _c("p", [
            _vm._v("Informe o Preço Unitário final para confirmar a exclusão:")
          ]),
          _c("v-currency-field", {
            attrs: {
              prefix: "R$ ",
              label: "Preço Unitário*",
              rules: [_vm.rules.required]
            },
            model: {
              value: _vm.pu,
              callback: function($$v) {
                _vm.pu = $$v
              },
              expression: "pu"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }